import { Feature, InjectorService } from '@tencent/workbench';
import { BaseFillFeature } from '@framework/workbench/drawer/ui/fill/base/base-fill-feature';
import { alphaToOpacity } from '@framework/workbench/drawer/utils';
import ImageQuickLookManager
    from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-quick-look-manager';
import { IImageFillShower } from '@tencent/drawing-drawer-components';
import { ImageFillFeature } from '@framework/workbench/drawer/ui/fill/image-fill/image-fill-feature';

@Feature()
export class ImageFillShower extends BaseFillFeature implements IImageFillShower {
    private imageFillFeature: ImageFillFeature;

    public constructor() {
        super();
        this.imageFillFeature = InjectorService.get(ImageFillFeature);
    }

    public getImageFillOpacity() {
        const opacityObj = { opacity: alphaToOpacity(this.imageFillFeature.value.imageAlpha) };
        return this.getShownValue(this.imageFillFeature.getInputParams().key, opacityObj);
    }

    public getImageFillType = () => this.imageFillFeature.value.curImgFillType;

    public getImageAlignType = () => this.imageFillFeature.value.curImageAlign;

    public getImageMirrorType = () => this.imageFillFeature.value.curMirrorImageType;

    public getImageSrc = (): string => ImageQuickLookManager.getInstance()
        .getDisplayUrl(this.imageFillFeature.image.src);

    public getImageTile = () => {
        const { tile } = this.imageFillFeature.value;
        const tx = this.getShownValue(this.imageFillFeature.getInputParams().key, { tileTx: tile.tx / 2 });
        const ty = this.getShownValue(this.imageFillFeature.getInputParams().key, { tileTy: tile.ty / 2 });
        const sx = this.getShownValue(this.imageFillFeature.getInputParams().key, { tileSx: tile.sx });
        const sy = this.getShownValue(this.imageFillFeature.getInputParams().key, { tileSy: tile.sy });

        return {
            tx,
            ty,
            sx,
            sy,
        };
    };

    public getImageOffset = () => {
        const { fillRect } = this.imageFillFeature.value;

        const l = this.getShownValue(
            this.imageFillFeature.getInputParams().key,
            { fillRectL: Math.round(fillRect.l * -100) },
        );
        const r = this.getShownValue(
            this.imageFillFeature.getInputParams().key,
            { fillRectR: Math.round(fillRect.r * -100) },
        );
        const t = this.getShownValue(
            this.imageFillFeature.getInputParams().key,
            { fillRectT: Math.round(fillRect.t * -100) },
        );
        const b = this.getShownValue(
            this.imageFillFeature.getInputParams().key,
            { fillRectB: Math.round(fillRect.b * -100) },
        );

        return {
            l,
            r,
            t,
            b,
        };
    };

    public getRotateWithShape = () => this.imageFillFeature.value.rotateWithShape === 1;

    public shouldRotateWithShapeDisable = () => this.isBackground();
}
